import * as routes from '../../constants/Routes';

/** URLs of the presence screens, under the existing event route. */
export const paths = {
  list: () => routes.HOME,
  detail: (id: string) => `${routes.EVENT}/${id}`,
  checkIn: (id: string) => `${routes.EVENT}/${id}/entrada`,
  inProgress: (id: string) => `${routes.EVENT}/${id}/permanencia`,
  checkOut: (id: string) => `${routes.EVENT}/${id}/saida`,
  result: (id: string) => `${routes.EVENT}/${id}/resultado`,
};
